import { ReactNode } from "react";
import { useFlutterwaveVerification } from "@/hooks/useFlutterwaveVerification";
import { usePaystackVerification } from "@/hooks/usePaystackVerification";

interface PaymentVerificationWrapperProps {
  children: ReactNode;
}

export function PaymentVerificationWrapper({
  children,
}: PaymentVerificationWrapperProps) {
  // These hooks will automatically verify payment if URL parameters exist
  useFlutterwaveVerification();
  usePaystackVerification();

  return <>{children}</>;
}
